/**
 * Represents the supported button types.
 */
class ButtonType {
  /**
   * Indicates a normal button.
   */
  static button = 'button';

  /**
   * Indicates a reset button.
   */
  static reset = 'reset';

  /**
   * Indicates a submit button.
   */
  static submit = 'submit';
}

Object.freeze(ButtonType);

export default ButtonType;
